import React, { useRef } from "react";
import { Form, Input, message } from "antd";
const { Search } = Input;

export default function PostalCodeAsyncTextInput({
  getFieldDecorator,
  label,
  name,
  disabled = false,
  required = false,
  requiredMessage = "Debe introducir un valor",
  callback,
  initialValue,
  pattern,
  maxLength = 5,
  readOnly,
  debounceDelay = 400,
  loading,
  placeholder,
  editMode = false,
}) {
  const timeoutRef = useRef(null);
  const mustDisable = !editMode && disabled ? true : false;

  const handleChange = (e) => {
    const value = e.target.value;

    // Limpia el timeout anterior
    clearTimeout(timeoutRef.current);

    // Configura uno nuevo
    timeoutRef.current = setTimeout(() => {
      if (value.length === 5) {
        callback(value);
      } else {
        // callback();
        return false;
      }
    }, debounceDelay);
  };

  return (
    <Form.Item label={label}>
      {getFieldDecorator(name, {
        initialValue: initialValue,
        rules: [
          {
            required: required,
            message: requiredMessage,
          },
          { 
            pattern: pattern, 
            message: requiredMessage 
          },
          { 
            max: 5, 
            message: "Máximo 5 caracteres"
          }
        ],
      })(
        <Search
          type="text"
          disabled={mustDisable}
          onChange={handleChange}
          maxLength={maxLength}
          readOnly={readOnly}
          loading={loading}
          placeholder={placeholder}
        />
      )}
    </Form.Item>
  );
}
